import { EmptyControl } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('KovanHrPersonnelSessionComparisonResultModel')
export class PersonnelSessionComparisonResultModel {
    @EmptyControl()
    @JsonProperty('peopleId', Number, true)
    peopleId: number = null;

    @EmptyControl()
    @JsonProperty('sessionPersonnel', Boolean, true)
    isSessionPersonnel: boolean = false;

    @EmptyControl()
    @JsonProperty('managedBySessionPersonnel', Boolean, true)
    isManagedBySessionPersonnel: boolean = false;
}
